import script from "./KikakuSubmit.vue?vue&type=script&setup=true&lang=ts"
export * from "./KikakuSubmit.vue?vue&type=script&setup=true&lang=ts"

import "./KikakuSubmit.vue?vue&type=style&index=0&id=6fe66e9f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe66e9f"]])

export default __exports__